import React from 'react';
import { MdAccessibility, MdMedicalServices, MdHome, MdPsychology, MdOutlineHandshake, MdOutlineHealthAndSafety } from 'react-icons/md';
import { FaWheelchair, FaHandsHelping, FaHeartbeat, FaUserNurse } from 'react-icons/fa';
import { IoMdQuote } from 'react-icons/io';
import { RiCustomerService2Fill } from 'react-icons/ri';
import './impact2.css';
import { Link } from 'react-router-dom';


function Impact2() {
  return (
    <div className="impact">
      {/* Hero Section */}
      <section className="impact__hero">
        <div className="hero__icon-container">
          <div className="hero__icon-wrapper">
            <MdAccessibility className="hero__icon" aria-hidden="true" />
            <div className="hero__icon-pulse" aria-hidden="true"></div>
          </div>
        </div>
        
        <div className="hero__content">
          <h1 className="hero__title">
            <span className="hero__title-gradient">Home Services for the Disabled</span>
            <span className="hero__subtitle">Empowering Independence</span>
          </h1>
          <p className="hero__description">
            Comprehensive, compassionate care designed to enhance quality of life and promote independence for individuals with disabilities.
          </p>
        </div>
      </section>

      {/* Stats Grid */}
      <section className="impact__stats">
        <div className="stats__grid">
          {[
            { 
              icon: <MdOutlineHealthAndSafety className="stats__icon stats__icon--blue" aria-hidden="true" />, 
              value: "98%", 
              title: "Client Satisfaction", 
              description: "Highest rated disability service provider",
              color: "blue"
            },
 
            { 
              icon: <MdOutlineHandshake className="stats__icon stats__icon--purple" aria-hidden="true" />, 
              value: "500+", 
              title: "Lives Impacted", 
              description: "Families supported through our services",
              color: "purple"
            },
            { 
              icon: <RiCustomerService2Fill className="stats__icon stats__icon--teal" aria-hidden="true" />, 
              value: "", 
              title: "Availability", 
              description: "Round-the-clock care when you need it",
              color: "teal"
            }

          ].map((stat, index) => (
            <article 
              key={index}
              className={`stats__card stats__card--${stat.color}`}
              aria-labelledby={`stat-title-${index}`}
            >
              <div className="stats__content">
                <div className="stats__icon-container">
                  {stat.icon}
                </div>
                <p className="stats__value">{stat.value}</p>
                <h3 className="stats__title" id={`stat-title-${index}`}>{stat.title}</h3>
                <p className="stats__description">{stat.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>



      {/* Testimonial Section */}
      <section className="impact__testimonial" aria-labelledby="testimonial-title">
        <div className="testimonial__bg-circle-1" aria-hidden="true"></div>
        <div className="testimonial__bg-circle-2" aria-hidden="true"></div>
        
        <div className="testimonial__content">
            <p id="testimonial-title">Our mission is to ensure that every individual, regardless of their circumstances, has access to the eye care they need through community eye care initiatives; 
              we strive to prevent avoidable blindness and safeguard the gift of sight for all.</p>
           
            <br /><p id="testimonial-title">Join us in our mission to create a world where everyone has the opportunity to experience the beauty of sight.</p>
          <div className="testimonial__author">
            <div className="author__icon" aria-hidden="true">
              <FaWheelchair className="author__icon-inner" />
            </div>

          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="impact__cta" aria-labelledby="cta-title">
        <div className="cta__bg-circles">
          <div className="cta__bg-circle-1" aria-hidden="true"></div>
          <div className="cta__bg-circle-2" aria-hidden="true"></div>
        </div>
        <div className="cta__content">
          <h2 className="cta__title" id="cta-title">Ready to Get Started?</h2>
          <p className="cta__description">
            Contact us today to discuss how we can support you or your loved one.
          </p>

          <Link to="/bookaneyescreeningfordisabled" className="cta__link">
          <button className="cta__button">
            Schedule a Consultation
            <svg className="cta__button-arrow" aria-hidden="true" viewBox="0 0 24 24">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </button></Link>

        </div>
      </section>
    </div>
  );
}

export default Impact2;